import { cn } from '@eliadmin/core/src/utils/style-utils';

export type VirtualListRenderItemFn<T> = (item: T, index: number) => React.ReactElement;
export type VirtualListProps<T> = {
  data: T[];
  renderItem: VirtualListRenderItemFn<T>;
  estimatedItemSize: number;
  keyExtractor: (item: T, i: number) => string;
  onEndReached?: () => void;
  /**
   * This is currently only supported on native.
   */
  onEndReachedThreshold?: number;
  className?: {
    main?: string;
    container?: string;
    items?: string;
    item?: string;
  };
};

/**
 * Simple non-virtualized fallback list.
 * Renders all items inside a scrollable container and preserves
 * the same public API as the virtualized version.
 */
export function VirtualList<T>(props: VirtualListProps<T>) {
  const { data, renderItem, keyExtractor, className } = props;

  return (
    <div
      className={cn('ea-virtual-list', className?.main)}
      style={{
        overflowY: 'auto',
        contain: 'strict',
      }}
    >
      <div className={cn('ea-virtual-list__container', className?.container)}>
        <div className={cn('ea-virtual-list__items', className?.items)}>
          {data.map((item, index) => (
            <div
              className={cn('ea-virtual-list__item', className?.item)}
              key={keyExtractor(item, index)}
              data-index={index}
            >
              {renderItem(item, index)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
